<template>
    <div class="dashboard-iframe h-100">
        <iframe width="100%" height="100%" class="border-0" :src="siteUrl" />
    </div>
</template>

<script>
    export default {
        name: "DashboardIframe",

        props: {
            screenUid: {
                type: String,
                required: true,
            },
            screen: {
                type: Object,
                required: false,
            },
        },

        computed: {
            siteUrl() {
                if(this.screen.options && this.screen.options.siteUrl) {
                    return this.screen.options.siteUrl;
                }
                return "";
            },
        },
    }
</script>

<style lang="scss" scoped>
    .dashboard-iframe {
    }
</style>
